/* ARBACH Duftproben 5 ml (Auftrag 34, 09.10.2026).

   Preisstufe OHNE Shopify-Rabatt: die Probe hat zwei Varianten, „einzeln“
   (3,00 €) und „ab 5 Proben“ (1,90 €). Liegen insgesamt mindestens 5 Proben
   im Warenkorb (Düfte gemischt), stehen ALLE Probenzeilen auf „ab 5 Proben“,
   darunter alle auf „einzeln“. Ein Produktrabatt ginge nicht: das
   Start-Angebot 2+1 kombiniert nicht mit Produktrabatten, einer fiele weg.

   abgleichen(): /cart.js lesen, falsche Zeilen mit derselben Menge und
   derselben Eigenschaft („Duft“) in der richtigen Variante dazulegen, DANACH
   die alten Zeilen auf 0 — scheitert der zweite Schritt, ist nichts verloren.
   Variant-IDs und Schwelle stehen als data-probe-einzeln / data-probe-ab /
   data-probe-schwelle am Proben-Kasten (snippets/produkt-probe.liquid) und
   an der Warenkorb-Sektion (sections/cart.liquid).

   Aufrufer:
     · Produktseite — „Probe hinzufügen“ legt per /cart/add.js nur die Probe
       dazu (die Seite bleibt stehen, Kopf-Zähler wird ersetzt), gleicht ab
       und meldet „Probe … liegt im Warenkorb“. Scheitert das Dazulegen,
       geht das Formular normal an /cart/add.
     · Warenkorbseite — beim Laden und nach jeder Mengenänderung
       (assets/arbach-warenkorb.js); hat sich etwas geändert, lädt die Seite
       neu (höchstens einmal in 8 s, damit sie sich nie im Kreis dreht).
   Wer an der Kasse vorbei will (z. B. „Jetzt kaufen“), hat schon abgeglichene
   Zeilen: jedes Dazulegen über den Kasten gleicht sofort ab. */
(function () {
  'use strict';
  if (window.arbachProben) return;

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function antwort(res) {
    if (!res.ok) { var f = new Error('HTTP ' + res.status); f.status = res.status; throw f; }
    return res.json();
  }
  function post(pfad, daten) {
    return fetch(wurzel() + pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(daten),
      credentials: 'same-origin'
    }).then(antwort);
  }
  function konfig() {
    var el = document.querySelector('[data-probe-einzeln]');
    if (!el) return null;
    var k = {
      einzeln: Number(el.getAttribute('data-probe-einzeln')),
      ab: Number(el.getAttribute('data-probe-ab')),
      schwelle: Number(el.getAttribute('data-probe-schwelle')) || 5
    };
    return (k.einzeln && k.ab) ? k : null;
  }

  // Probenzeilen auf die richtige Stufe stellen. Ergebnis: true = geändert.
  function abgleichen() {
    var k = konfig();
    if (!k || !window.fetch || !window.Promise) return Promise.resolve(false);
    return fetch(wurzel() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(antwort)
      .then(function (korb) {
        var zeilen = (korb.items || []).filter(function (z) { return z.variant_id === k.einzeln || z.variant_id === k.ab; });
        var n = zeilen.reduce(function (s, z) { return s + z.quantity; }, 0);
        var ziel = n >= k.schwelle ? k.ab : k.einzeln;
        var falsch = zeilen.filter(function (z) { return z.variant_id !== ziel; });
        if (!falsch.length) return false;
        var neu = falsch.map(function (z) { return { id: ziel, quantity: z.quantity, properties: z.properties || {} }; });
        return post('cart/add.js', { items: neu }).then(function () {
          var weg = {};
          falsch.forEach(function (z) { weg[z.key] = 0; });
          return post('cart/update.js', { updates: weg });
        }).then(function () { return true; });
      });
  }

  function neuLaden() {
    try {
      var zuletzt = Number(window.sessionStorage.getItem('arbachProbenNeu')) || 0;
      if (Date.now() - zuletzt < 8000) return;
      window.sessionStorage.setItem('arbachProbenNeu', String(Date.now()));
    } catch (e) { /* ohne Speicher trotzdem neu laden */ }
    window.location.reload();
  }

  // Kopf-Zähler aus dem mitgelieferten HTML der Sektion shop-header (wie arbach-warenkorb.js)
  function kopf(html) {
    if (!html || !window.DOMParser) return;
    var neu = new DOMParser().parseFromString(html, 'text/html');
    var alt = document.querySelectorAll('[data-kopf-warenkorb]');
    var frisch = neu.querySelectorAll('[data-kopf-warenkorb]');
    for (var i = 0; i < alt.length && i < frisch.length; i++) alt[i].innerHTML = frisch[i].innerHTML;
  }

  // ---------------------------------------------------------- Produktseite
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-arbach-probe-form]')) return;
    if (!window.fetch || !window.Promise) return;                      // Formular wie gewohnt
    var kasten = f.closest('[data-arbach-probe]');
    var knopf = f.querySelector('button[type="submit"]');
    var auswahl = f.querySelector('select');
    var meldung = kasten && kasten.querySelector('.arbach-probe__meldung');
    var id = Number((f.querySelector('input[name="id"]') || {}).value);
    if (!kasten || !id) return;
    e.preventDefault();
    if (knopf && knopf.disabled) return;
    if (knopf) { knopf.disabled = true; knopf.setAttribute('aria-busy', 'true'); }
    if (meldung) meldung.textContent = '';
    var duft = auswahl ? auswahl.value : '';

    post('cart/add.js', {
      items: [{ id: id, quantity: 1, properties: { Duft: duft } }],
      sections: 'shop-header',
      sections_url: window.location.pathname
    }).then(function (daten) {
      kopf(daten && daten.sections && daten.sections['shop-header']);
      // Abgleich darf scheitern — die Warenkorbseite holt ihn nach.
      return abgleichen().catch(function () { return false; });
    }).then(function () {
      if (!meldung) return;
      meldung.textContent = (kasten.getAttribute('data-ok') || '').replace('[duft]', duft) + ' ';
      var a = document.createElement('a');
      a.href = kasten.getAttribute('data-warenkorb-url') || (wurzel() + 'cart');
      a.textContent = kasten.getAttribute('data-warenkorb-text') || '';
      meldung.appendChild(a);
    }, function () {
      // Dazulegen gescheitert (auch 429): kurz sagen, dann das Formular ohne Skript
      if (meldung) meldung.textContent = kasten.getAttribute('data-fehler') || '';
      window.setTimeout(function () { HTMLFormElement.prototype.submit.call(f); }, 1200);
      return 'fehler';
    }).then(function (ergebnis) {
      if (ergebnis === 'fehler') return;
      if (knopf) { knopf.disabled = false; knopf.removeAttribute('aria-busy'); }
    });
  });

  // -------------------------------------------------------- Warenkorbseite
  function beimLaden() {
    if (!document.querySelector('[data-warenkorb][data-probe-einzeln]')) return;
    abgleichen().then(function (geaendert) { if (geaendert) neuLaden(); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beimLaden);
  else beimLaden();

  window.arbachProben = { abgleichen: abgleichen, neuLaden: neuLaden };
})();
